import React from 'react';
import {withRouter} from 'react-router';
import {DI} from 'modules';

// Components
import SearchForm from 'components/search-form';

function HeaderView(props) {
  const {
    render = () => {},
    editButton = () => {},
    viewButton = () => {},
    history = [],
    buttonBackNameOfStr = '',
    common,
    user,
    defaultBackUrl = `/${common.locale}`,
    alwaysBackToDefault,
  } = props;

  const goToLives = () =>
    history.length > 1 && !alwaysBackToDefault ? history.goBack() : history.push(defaultBackUrl);
  const adminGroup = user.currentUser.payload.admin_group === 'super_admin';

  return (
    <div className="live-top">
      <button className="page__back" onClick={goToLives} type="button">
        <span className="page__back--desk">{common.strings[buttonBackNameOfStr]}</span>
        <span className="page__back--mobile">{common.strings[buttonBackNameOfStr]}</span>
      </button>

      <div className="live-top__search">
        {!common.isMobile && <SearchForm />}
      </div>

      {adminGroup && editButton(props)}
      <div className="live-top-side">
        <div className="live-share">{render(props)}</div>
      </div>

      {adminGroup && viewButton(props)}
      <div className="live-top-side">
        <div className="live-share">{render(props)}</div>
      </div>
    </div>
  );
}

export default DI(['common', 'user'])(withRouter(HeaderView));
